import React, { useState } from "react";
import "./MyAccount.css";
import OrderHistory from "./OrderHistory";
import UpdateProfile from "./UpdateProfile";
import Addresses from "./Addresses";
import Settings from "./Settings";
import Wishlist from "./Wishlist";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const MyAccount = () => {
  const [activeTab, setActiveTab] = useState("orders");
  const { getUserDetails, logout } = useAuth();
  const navigate = useNavigate();
  let user = getUserDetails();
  user = JSON.parse(user) || {};
  //   const [userDetails, setUserDetails] = useState(JSON.parse(user) || {});

  const tabs = [
    { id: "orders", label: "Order History", icon: "📦" },
    { id: "wishlist", label: "Wishlist", icon: "❤️" },
    // { id: "profile", label: "Update Profile", icon: "👤" },
    { id: "addresses", label: "Address", icon: "📍" },
    // { id: "settings", label: "Settings", icon: "⚙️" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "orders":
        return <OrderHistory />;
      case "wishlist":
        return <Wishlist />;
      //   case "profile":
      //     return <UpdateProfile />;
      case "addresses":
        return <Addresses />;
      //   case "settings":
      //     return <Settings />;
      default:
        return <OrderHistory />;
    }
  };

  return (
    <div className="my-account-container">
      <div className="account-wrapper">
        {/* Sidebar */}
        <div className="account-sidebar">
          <div className="account-user-info">
            <div className="user-avatar">
              <svg
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <h3 className="user-name">{user?.name}</h3>
            <p className="user-email">{user?.email}</p>
          </div>

          <nav className="account-nav">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`nav-tab ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="tab-arrow"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            ))}
          </nav>

          <button
            className="logout-btn"
            onClick={() => {
              logout();
              navigate("/login");
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Logout
          </button>
        </div>

        {/* Main Content */}
        <div className="account-content">{renderContent()}</div>
      </div>
    </div>
  );
};

export default MyAccount;
